<template>
    <div
        v-if="isVisible"
        class="widget beta-access-widget"
    >
        <p class="tagline">
            Get Beta Access!
        </p>
        <h3>Sign up to test upcoming features and tools.</h3>
        <p class="text">
            Stay one step ahead of what's on the horizon by joining our beta program. It's a great way to get in on the action before everyone else with exclusive access to new products, features, and tools!
        </p>
        <p class="text">
            <strong>Here's what you can expect:</strong>
        </p>
        <ul>
            <li>Beta Release Notes</li>
            <li>Early access to beta products and tools</li>
            <li>Beta feedback widget (coming soon)</li>
        </ul>
        <base-submit-button
            class="btn is-green"
            :class="{'is-loading': isLoading}"
            :disabled="isLoading"
            @click="onClick"
        >
            Get Beta Access
        </base-submit-button>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import toasts from '@/mixins/toasts';

export default {
    mixins: [toasts],

    /**
     * @returns {Array} Data.
     */
    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        /**
         * @returns {object} Sorted widgets.
         */
        isVisible() {
            return ! this.$store.getters.getUserMeta('beta_access');
        },
    },

    methods: {
        ...mapActions([
            'setUserMeta',
        ]),

        /**
         * Handle form submit.
         *
         * @returns {void}
         */
        onClick() {
            this.isLoading = true;

            this.setUserMeta({ beta_access: true }).then(() => {
                this.toastSuccess({
                    message: {
                        title: 'You have been signed up for beta access!',
                    },
                });
            });
        },
    },
};

</script>
